import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItemProps,
  MenuProvider,
  MenuSeparator,
  useDialogContext,
} from "@ariakit/react";
import { classNames } from "@indietabletop/appkit/class-names";
import { ReactNode } from "react";
import { Link } from "wouter";
import { atomic } from "../atomic.css";
import { Icon } from "../icon";
import * as iconButtonCss from "../icon-button/style.css";
import * as css from "./style.css";

export function ActionsMenu(props: { children: ReactNode }) {
  return (
    <MenuProvider placement="top-end">
      <MenuButton className={iconButtonCss.button}>
        <div className={iconButtonCss.iconHover} />
        <Icon name="menu" title="Actions" />
      </MenuButton>

      <Menu
        className={classNames(
          atomic({
            border: "solid",
            paddingBlock: 8,
            paddingInline: 8,
            backgroundColor: "background-primary",
            zIndex: "menu",
          }),
          css.menu,
        )}
      >
        {props.children}
      </Menu>
    </MenuProvider>
  );
}

const menuItem = atomic({
  cursor: "pointer",
  paddingBlock: {
    default: 6,
    coarse: 12,
  },
  paddingInline: {
    default: 6,
    coarse: 12,
  },
  transition: "background-color",
  backgroundColor: { hover: "background-secondary" },
});

export function MenuDialogDisclosure(props: MenuItemProps) {
  const dialog = useDialogContext();

  if (!dialog) {
    throw new Error("MenuDialogDisclosure must appear within dialog context.");
  }

  return <MenuItem {...props} onClick={dialog.show} className={menuItem} />;
}

export function MenuLink(props: { href: string; children: ReactNode }) {
  return (
    <MenuItem render={<Link href={props.href} />} className={menuItem}>
      {props.children}
    </MenuItem>
  );
}

export function MenuDivider() {
  return (
    <MenuSeparator
      className={atomic({
        borderBlockEnd: "dashed",
        marginBlock: 12,
        marginInline: 6,
      })}
    />
  );
}
